import React, { Component } from "react";
import { Link } from "react-router-dom";

const SubmenuMarcas = ({ mobile, ocultarMenu }) => {

  return (
    <div 
    style={mobile?
    {
      position: "relative",
      left: "5%",
      top: 25,
      width: "100%",
      backgroundColor: "#242e37",
    }:
    {
      position: "absolute",
      marginTop: -32,
      width: 100,
      height: 172,
      background: "rgba(217, 217, 217, 0.05)",
      paddingLeft: 12,
      paddingTop: 44,
      paddingBottom: 12,
      paddingRight: 12,
      marginLeft: -12,
      borderRadius: 5,
    }}>
      <a className="subItemNavBar" href="https://coppens.com.ar">Coppens</a>
      <a className="subItemNavBar" href="https://emege.com.ar">Emegé</a>
      <a className="subItemNavBar" href="https://uniqo.com.ar">Uniqo</a>
    </div>
  );
};

export default SubmenuMarcas;
